module.exports = __webpack_public_path__ + "static/media/share.ce604498.svg";